export default __webpack_public_path__ + "static/media/undraw_mail.a94e0fc6.png";